<label [ngClass]="['checkbox-label', checkboxColor || '']">
    <input type="checkbox" [disabled]="disabled" [checked]="checked" (change)="onCheckboxChange($event)">
    <span class="checkbox-custom"></span>
</label>
